import{a as t}from"./chunk-DEVKGLTN.js";import{a as n}from"./chunk-RAAYCPUM.js";function a(...e){return n(o,e)}var o=e=>t(e).join("_").toLowerCase();export{a};
